<template>
  <div class="product-category">
    <section-header tag="h1" class="mt-5 mb-5" :title="header.title" :subtitle="header.subtitle"/>
    <list-control-panel class="mb-5"
      :layout="layout" @layout="onLayoutChanged"
      :sort="sort" @sort="onSortChanged"
      :limit="limit" @limit="onLimitChanged"/>
    <product-grid :products="products" v-show="layout === layoutOptions.GRID"/>
    <product-list :products="products" v-show="layout === layoutOptions.LIST"/>
    <list-pagination :page="page" :limit="limit" :total="total" @page="onPageChanged" />
  </div>
</template>

<script>
import constant from '@/constant.js'
import { mapGetters, mapMutations } from 'vuex'
import productApi from '@/api/product.js'
import SectionHeader from '@/components/SectionHeader.vue'
import ListControlPanel from '@/components/ListControlPanel.vue'
import ListPagination from '@/components/ListPagination.vue'
import ProductGrid from '@/components/Product/ProductGrid.vue'
import ProductList from '@/components/Product/ProductList.vue'

export default {
  name: 'ProductCategory',
  components: {
    SectionHeader,
    ListControlPanel,
    ListPagination,
    ProductGrid,
    ProductList
  },
  data: function () {
    return {
      products: null,
      total: 0
    }
  },
  computed: {
    ...mapGetters([
      'categories'
    ]),
    layoutOptions: function () {
      return constant.PRODUCT_LAYOUT
    },
    catId: function () {
      return this.$route.params.id
    },
    layout: function () {
      var ret = this.$route.query.layout
      if (!ret) {
        ret = constant.PRODUCT_LAYOUT.GRID
      }
      return ret
    },
    sort: function () {
      var ret = this.$route.query.sort
      if (!ret) {
        ret = constant.FILTER.SORT[0].value
      }
      return ret
    },
    limit: function () {
      var ret = this.$route.query.limit
      if (!ret) {
        ret = constant.FILTER.LIMIT[0]
      }
      return Number(ret)
    },
    page: function () {
      var ret = this.$route.query.page
      if (!ret) {
        ret = 0
      }
      return Number(ret)
    },
    category: function () {
      var ret = null
      if (this.categories && parseInt(this.catId)) {
        var self = this
        var cat = this.categories.find(e => e.catId === parseInt(self.catId))
        if (cat) {
          ret = cat
        }
      }
      return ret
    },
    isActivity: function () {
      var ret = false
      if (this.catId) {
        switch (this.catId) {
          case constant.ACTIVITY_TYPE.NEW:
          case constant.ACTIVITY_TYPE.HOT:
          case constant.ACTIVITY_TYPE.PROMOTE:
            ret = true
            break
          default:
            break
        }
      }
      return ret
    },
    header: function () {
      var ret = { title: null, subtitle: null }
      if (this.catId) {
        switch (this.catId) {
          case constant.ACTIVITY_TYPE.NEW:
            ret.title = '新品推薦'
            ret.subtitle = 'New Arrival'
            break
          case constant.ACTIVITY_TYPE.HOT:
            ret.title = '熱銷單品'
            ret.subtitle = 'Best Seller'
            break
          case constant.ACTIVITY_TYPE.PROMOTE:
            ret.title = '特價商品'
            ret.subtitle = 'On Sale'
            break
          default:
            if (this.category && this.category.catName) {
              var regex = this.category.catName.match(/\s[0-9a-zA-Z]/)
              if (regex) {
                var index = regex.index
                ret.title = this.category.catName.substring(0, index)
                ret.subtitle = this.category.catName.substring(index)
              } else {
                ret.title = this.category.catName
                ret.subtitle = ''
              }
            }
            break
        }
      }
      return ret
    }
  },
  watch: {
    catId: function (value) {
      this.apiGetProductTotal()
      this.refresh()
    },
    page: function (value) {
      this.refresh()
    },
    limit: function (value) {
      this.refresh()
    },
    sort: function (value) {
      this.refresh()
    }
  },
  mounted: function () {
    this.apiGetProductTotal()
    this.apiGetProducts()
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetProducts: function () {
      var self = this
      var api
      if (this.isActivity) {
        api = productApi.getActivityProducts
      } else {
        api = productApi.getCategoryProducts
      }
      var filter = {
        page: this.page,
        limit: this.limit,
        sort: this.sort
      }
      api(this.catId, filter, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.products = rspData
      })
    },
    apiGetProductTotal: function () {
      var self = this
      var api
      if (this.isActivity) {
        api = productApi.getActivityTotal
      } else {
        api = productApi.getCategoryTotal
      }
      api(this.catId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.total = rspData
      })
    },
    refresh: function () {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      this.apiGetProducts()
    },
    onLayoutChanged: function (value) {
      if (!value) {
        return
      }
      this.$router.push(`/w/product/category/${this.catId}?layout=${value}&sort=${this.sort}&page=${this.page}&limit=${this.limit}`)
    },
    onSortChanged: function (value) {
      if (!value) {
        return
      }
      this.$router.push(`/w/product/category/${this.catId}?layout=${this.layout}&sort=${value}&page=${this.page}&limit=${this.limit}`)
    },
    onLimitChanged: function (value) {
      if (!value) {
        return
      }
      this.$router.push(`/w/product/category/${this.catId}?layout=${this.layout}&sort=${this.sort}&page=0&limit=${value}`)
    },
    onPageChanged: function (value) {
      this.$router.push(`/w/product/category/${this.catId}?layout=${this.layout}&sort=${this.sort}&page=${value}&limit=${this.limit}`)
    }
  }
}
</script>

<style scoped>
</style>
